export default __webpack_public_path__ + "static/media/flagship.20a7694d.jpg";